import { wsService } from "./wsService";
const api_url = process.env.VUE_APP_API_URL;
const section = "lpn_labels";
import axios from "axios";

const FLOW_TYPE_RECEPTION = "I";
const FLOW_TYPE_EXPEDITION = "O";

const STATE_NO_USED = "N";
const STATE_LOCATED = "L";
const STATE_RECEIVED = "R";
const STATE_PICKED = "P";
const STATE_SHIPPED = "E";


function filter(param = { enable: true }) {
  /*PARAMS:
  code: string
  flow_type: string

  almacen.id: integer
  zona.id: integer
  ubicacion.id: integer
  product.id: integer
  */
  return wsService.make_post_request(section + "/list", param);
}

function filter_assigned_locations(param = {}) {
  /*PARAMS:
  code: string
  flow_type: string

  almacen.id: integer
  zona.id: integer
  ubicacion.id: integer
  product.id: integer
  */
  return wsService.make_post_request(section + "/filter-assigned-locations", param);
}

function scan(param = {}) {  
  /*PARAMS:
  lpn.id: integer
  lpn_code: string
  */
  return wsService.make_post_request(section + "/scan", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function getHistory(param = {}) {
  //return wsService.make_post_request(section + "/history/" + code, param);
  return wsService.make_post_request(section + "/history", param);
}

function getInboundNotUsed(almacen_id) {
  var param = {
    flow_type: FLOW_TYPE_RECEPTION,
    state: { "id": STATE_NO_USED },
    almacen: { "id": almacen_id },
    from: 0,
    limit: 100,
  };
  return wsService.make_post_request(section + "/list", param);
}

function getOutboundNotUsed() {
  var param = {
    flow_type: FLOW_TYPE_EXPEDITION,
    state: { "id": STATE_NO_USED },
  };
  param = {};
  return wsService.make_post_request(section + "/list", param);
}

function print(param = {}, type) {
  var url = "";
  if (type == "zpl") {
    url = section + "/print/label/bulk/termica_zpl";
  }
  if (type == "pdf") {
    url = section + "/print/label/bulk/termica_pdf";
  }
  const token = localStorage.getItem("token");
  return axios.post(api_url + url, param, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + token,
    },
  });
}

function list_states(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-states", param);
}

export const lpnService = {
  section,
  filter,
  filter_assigned_locations,
  remove,
  create,
  update,
  print,
  getHistory,
  getInboundNotUsed,
  getOutboundNotUsed,
  scan,
  list_states,
  FLOW_TYPE_RECEPTION,
  FLOW_TYPE_EXPEDITION,
  STATE_NO_USED,
  STATE_LOCATED,
  STATE_RECEIVED,
  STATE_PICKED,
  STATE_SHIPPED,
};
